<template>
  <svg
    width="2"
    height="20"
    viewBox="0 0 2 20"
  >
    <path d="M0.25 0.75V19.25C0.25 19.6642 0.585786 20 1 20C1.41421 20 1.75 19.6642 1.75 19.25V0.75C1.75 0.335786 1.41421 0 1 0C0.585786 0 0.25 0.335786 0.25 0.75Z" />
  </svg>
</template>
